import React, { useEffect } from 'react';

import { useFormContext } from 'react-hook-form';

import { Skeleton } from '@mui/lab';

import { Option } from 'components/shared/ControlledFields/ControlledSelect';
import { Autocomplete } from 'components/shared/index';

import { BASE_REPORTS, REPORT_TYPES } from '../type';
import { useConcatReportTypes } from './hooks/useConcatReportTypes';
import { isNil } from 'ramda';
import { useTranslation } from 'react-i18next';

type SelectReportTypeProps = {
  setFormType: React.Dispatch<REPORT_TYPES>;
  forcedDefaultReportType?: REPORT_TYPES;
};

const SelectReportType = ({
  setFormType,
  forcedDefaultReportType
}: SelectReportTypeProps) => {
  const { t } = useTranslation('common', {
    keyPrefix: 'adminPortal.procedures.reports'
  });
  const { reset } = useFormContext();
  const { sortedItems: selectionOptions, isFetching } = useConcatReportTypes();

  const planningObj = {
    value: BASE_REPORTS.PROJECTPLANNING_REPORT,
    label: t(`${forcedDefaultReportType}`)
  };

  useEffect(() => {
    if (!isNil(forcedDefaultReportType))
      setFormType(BASE_REPORTS.PROJECTPLANNING_REPORT);
  }, [forcedDefaultReportType]);

  if (!isNil(forcedDefaultReportType)) {
    return (
      <Autocomplete
        disabled
        fullWidth
        variant="outlined"
        label={''}
        defaultValue={planningObj}
        onSelected={(item: Option | null) => {
          item && setFormType(item.value as REPORT_TYPES);
          reset();
        }}
        options={[planningObj]}
        idProperty={'value'}
      />
    );
  } else
    return (
      <>
        {!isFetching ? (
          <Autocomplete
            fullWidth
            variant="outlined"
            label={''}
            onSelected={(item: Option | null) => {
              item && setFormType(item.value as REPORT_TYPES);
              reset();
            }}
            options={selectionOptions}
            idProperty={'value'}
          />
        ) : (
          <Skeleton />
        )}
      </>
    );
};

export default SelectReportType;
